export default __webpack_public_path__ + "static/media/slide_1.05395af1.png";